import { render, staticRenderFns } from "./digest.vue?vue&type=template&id=70c7b6fe&scoped=true&"
import script from "./digest.vue?vue&type=script&lang=js&"
export * from "./digest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c7b6fe",
  null
  
)

export default component.exports